import React, { useState, useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, CircularProgress, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./styles.module.css";
import { clinicRegistration } from "../../../JsonForms/ClinicRegistration";
import { clinicDetails } from "../../../JsonForms/ClinicDetails";
import { axiosProxyInstance, axiosAppInstance } from "../../../utils/request";
import BillingAccordian from "../../../components/PractitionerEdit/Billing";
import { useParams } from 'react-router-dom';
import Address from "../../../components/PractitionerEdit/Address";
import Accesible from "../../../components/PractitionerEdit/Accessible";
import Appointment from "../../../components/PractitionerEdit/Appointment";
import Business from "../../../components/PractitionerEdit/Business";
import Clinic from "../../../components/PractitionerEdit/Clinic";
import Insurance from "../../../components/PractitionerEdit/Insurance";
import Opening from "../../../components/PractitionerEdit/Opening";
import Parking from "../../../components/PractitionerEdit/Parking";
import Practising from "../../../components/PractitionerEdit/Practising";
import Speciality from "../../../components/PractitionerEdit/Speciality";

const PractitionerEdit = (props) => {
    const { stripePromise } = props;
    const [expandedPanels, setExpandedPanels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [details, setDetails] = useState([]);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);
    const { clinicId } = useParams();

    const handleChange = (panel) => () => {
        setExpandedPanels((prev) =>
            prev.includes(panel) ? prev.filter((p) => p !== panel) : [...prev, panel]
        );
    };

    const addressSection = clinicRegistration.sections.find(sec => sec.sectionNo === 1);
    const practisingSection = clinicRegistration.sections.find(sec => sec.sectionNo === 2);
    const specialitySection = clinicRegistration.sections.find(sec => sec.sectionNo === 3);
    const appointmentSection = clinicDetails.sections.find(sec => sec.sectionNo === 1);
    const openingSection = clinicDetails.sections.find(sec => sec.sectionNo === 2);
    const parkingSection = clinicDetails.sections.find(sec => sec.sectionNo === 3);
    const accessibleSection = clinicDetails.sections.find(sec => sec.sectionNo === 4);
    const insuranceSection = clinicDetails.sections.find(sec => sec.sectionNo === 5);
    const descriptionSection = clinicDetails.sections.find(sec => sec.sectionNo === 6);
    const businessSection = clinicDetails.sections.find(sec => sec.sectionNo === 7);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const response = await axiosProxyInstance.get(`/listing/${clinicId}?post_status=all`);
                setDetails(response.data.data ?? []);
                setLoading(false);
            } catch (err) {
                setError("Failed to fetch listings");
                setLoading(false);
            }
        };
        fetchDetails();
    }, []);

    const fetchSubcaription = async (subId) => {
        try {
          const response = await axiosAppInstance.get(`https://api.stripe.com/v1/subscriptions/${subId}`, {
            headers: {
                "Authorization": "Bearer " + process.env.REACT_APP_STRIPE_SECRET_KEY,
                "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        //   const response = await axiosAppInstance.get(`https://api.stripe.com/v1/subscriptions/search/${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`);
          if(response && response?.data && response?.data?.status){
            setSubscriptionStatus(response?.data?.status);
          }
          
        //   setDetails(response.data.data ?? []);
        //   setLoading(false);
        } catch (err) {
        //   setError("Failed to fetch listings");
        //   setLoading(false);
        }
      };
    useEffect(() => {
            if (!stripePromise) return;
            if(details?.payment_info?.payment_subscriptions){
                fetchSubcaription(details?.payment_info?.payment_subscriptions);
            }
            
        }, [stripePromise, details]);

    if (loading) {
        return (
            <Box className={styles.loaderContainer}>
                <CircularProgress className={styles.loader} />
            </Box>
        );
    }
    return (
        <Box className={styles.mainContainer}>
            <Typography variant="gothamSmall" className={styles.settingsTitle}>Your Listings {'>'} Edit</Typography>
            <Typography variant="gothamXL" className={styles.settingsTitle}>Edit Your Listing</Typography>
            <Box className={styles.settingsContainer}>
                <Accordion
                    expanded={expandedPanels.includes("address")}
                    onChange={handleChange("address")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("address") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Address</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Address details={details} sectionData={addressSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>

                <Accordion
                    expanded={expandedPanels.includes("practising")}
                    onChange={handleChange("practising")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("practising") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Practising Physiotherapists</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Practising details={details} sectionData={practisingSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>

                <Accordion
                    expanded={expandedPanels.includes("speciality")}
                    onChange={handleChange("speciality")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("speciality") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Area of Speciality</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Speciality details={details} sectionData={specialitySection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("appointment")}
                    onChange={handleChange("appointment")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("appointment") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Appointment Prices</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Appointment details={details} sectionData={appointmentSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("opening")}
                    onChange={handleChange("opening")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("opening") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Opening Times</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Opening details={details} sectionData={openingSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("parking")}
                    onChange={handleChange("parking")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("parking") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Available Parking</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Parking details={details} sectionData={parkingSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("accessible")}
                    onChange={handleChange("accessible")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("accessible") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Accessible Access</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Accesible details={details} sectionData={accessibleSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("insurance")}
                    onChange={handleChange("insurance")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("insurance") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Insurance Accepted</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Insurance details={details} sectionData={insuranceSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("clinic")}
                    onChange={handleChange("clinic")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("clinic") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Clinic Description</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Clinic details={details} sectionData={descriptionSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>


                <Accordion
                    expanded={expandedPanels.includes("business")}
                    onChange={handleChange("business")}
                    className={styles.accordion}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={!expandedPanels.includes("business") ? styles.accordionSummary : ""}>
                        <Typography variant="gothamLarge" className={styles.accordionTitle}>Business Logo</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Business details={details} sectionData={businessSection} />
                    </AccordionDetails>
                    <Divider className="margin-top-15" />
                </Accordion>

                <BillingAccordian 
                    details={details} handleChange={handleChange} expandedPanels={expandedPanels}
                    subscriptionStatus={subscriptionStatus}
                />
            </Box>
        </Box>
    )
}
export default PractitionerEdit;